import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {LoadingIndicator} from "../../../core/components/loading/loading-indicator";
import classNames from 'classnames';
import styles from '../styles/placeholder/outrights-widget-placeholder.module.scss';
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const OutrightsWidgetAsyncComponent = AsyncComponent(async () => import('./outrights-widget' /* webpackChunkName: "outrights-widget" */ ));

export const OutrightsWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper>
    <React.Suspense fallback={<div className={classNames(styles.placeholder)}><LoadingIndicator/></div>}>
      <OutrightsWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
};
